const dateTimeFormat = "DD/MM/YYYY HH:mm:ss";
const dateFormat = "DD/MM/YYYY";

const localeDateTimeOptions = {
  month: "2-digit",
  day: "2-digit",
  year: "numeric",
  hour12: false,
  hour: "2-digit",
  minute: "2-digit",
} as const;

const defaultDbo = 90;
const defaultDqo = 220;

export {
  dateTimeFormat,
  dateFormat,
  localeDateTimeOptions,
  defaultDbo,
  defaultDqo,
};
